import TransactionClient from './TransactionClient';
import HttpClient from '../../gateway/HttpClient';
import { notUndefined } from '../../util/Assert';
import { SandboxHistoryJsonModel, TransactionJsonModel, TransactionRequestType } from '../../domain/stream/transaction/TransactionDomains';
import HttpMethod from '../../constant/HttpMethod';
import { EventMethods, EventVariableMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { GeneralResponse } from '../../domain/gateway/ApiResponse';
import { ActionType } from '../../constant/Constants';
import { ChannelUndeployDependent } from '../../domain/stream/transaction/ChannelUndeployDependent';
import Query = query.Query;

class NestTransactionClient implements TransactionClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public save(event: TransactionJsonModel): Promise<void> {
    const dto = { id: event.name, object: event };
    return this.httpClient.execute(HttpMethod.POST, EventMethods.SAVE, dto);
  }

  public getCount(_query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, EventMethods.COUNT, _query);
  }

  public async remove(name: string): Promise<any> {
    return this.httpClient.execute(HttpMethod.DELETE, `${EventVariableMethods.REMOVE}/${name}`);
  }

  public deploy(name: string): Promise<GeneralResponse> {
    return this.httpClient.execute<GeneralResponse>(HttpMethod.POST, `${EventMethods.DEPLOY}/${name}`);
  }

  public undeploy(name: string): Promise<any> {
    return this.httpClient.execute(HttpMethod.POST, `${EventMethods.UNDEPLOY}/${name}`);
  }

  public listUndeployDependents(id: string): Promise<ChannelUndeployDependent[]> {
    return this.httpClient.execute(HttpMethod.GET, `${EventMethods.UNDEPLOY_DEPENDENTS}/${id}`);
  }

  public isExist(name: string): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.GET, `${EventMethods.EXIST}/${name}`);
  }

  public getNames(): Promise<string[]> {
    return this.httpClient.execute(HttpMethod.GET, EventMethods.GET_NAMES);
  }

  public getByName(name: string): Promise<TransactionJsonModel | undefined> {
    return this.httpClient.execute(HttpMethod.GET, `${EventMethods.GET_BY_NAME}/${name}`);
  }

  public sendEvent(method: TransactionRequestType, name: string, body: Record<string, any>, key: string, id: string | undefined, test: boolean): Promise<any> {
    const payload = {
      method,
      id,
      body,
    };
    return this.httpClient.execute(HttpMethod.POST, EventMethods.SEND, payload);
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, EventMethods.BULK_ACTION, payload);
  }

  public getHistory(date: string): Promise<SandboxHistoryJsonModel> {
    return this.httpClient.execute(HttpMethod.GET, `${EventMethods.GET_HISTORY}/${date || '1'}`);
  }

  public pinHistory(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${EventMethods.PIN_HISTORY}/${id}`);
  }
  public deleteHistory(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${EventMethods.DELETE_HISTORY}/${id}`);
  }
}

export default NestTransactionClient;
